import { render } from "./OperatorEditForm.vue?vue&type=template&id=37ac5d44"
import script from "./OperatorEditForm.vue?vue&type=script&lang=ts"
export * from "./OperatorEditForm.vue?vue&type=script&lang=ts"

import "./OperatorEditForm.vue?vue&type=style&index=0&id=37ac5d44&lang=scss"
script.render = render

export default script